'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M192 0v1024h768v-1024h-768zM576 256.33c70.51 0 127.67 57.16 127.67 127.67s-57.16 127.67-127.67 127.67-127.67-57.16-127.67-127.67 57.16-127.67 127.67-127.67v0zM768 768h-384v-64c0-70.696 57.306-128 128-128v0h128c70.696 0 128 57.304 128 128v64z' }),
        React.createElement('path', { d: 'M64 64h96v192h-96v-192z' }),
        React.createElement('path', { d: 'M64 320h96v192h-96v-192z' }),
        React.createElement('path', { d: 'M64 576h96v192h-96v-192z' }),
        React.createElement('path', { d: 'M64 832h96v192h-96v-192z' })
    ));
};